import { request } from '@/shared/api/request'

export const findOne = (dictCode, params) => {
	return request({ url: `dict/${dictCode}/findOne`, method: 'GET', params })
}
